<template>
  <div>
    <div>
      <h4 class="title">横幅专区</h4>
      <ImageList
      imageDescribes="横幅专区"
        :imageType="imageTypes.default_home"
        :maxImageNum="1"
        :imageWidth="1050"
        :imageHeight="412"
      ></ImageList>
    </div>

    <div>
      <h4 class="title">手机端横幅专区</h4>
      <ImageList
      imageDescribes="手机端横幅专区"
        :imageType="imageTypes.default_home_m"
        :maxImageNum="1"
        :imageWidth="750"
        :imageHeight="295"
      ></ImageList>
    </div>

    <div>
      <h4 class="title">默认视频</h4>
      <ImageList
      imageDescribes="默认视频"
        :imageType="imageTypes.video"
        :maxImageNum="1"
        :imageWidth="580"
        :imageHeight="0"
        inputModelName="linkUrl"
        inputTitle="视频链接"
      ></ImageList>
    </div>

    <div>
      <h4 class="title">广告banner位图片</h4>
      <ImageList
        :imageType="imageTypes.adv"
        imageDescribes="广告banner位图片"
        :maxImageNum="6"
        :imageWidth="580"
        :imageHeight="110"
        inputModelName="linkUrl"
        inputTitle="banner跳转链接"
      ></ImageList>
    </div>

    <div>
      <h4 class="title">专场海报设置</h4>
      <ImageList
        :imageType="imageTypes.poster"
        imageDescribes="专场海报设置"
        :maxImageNum="6"
        :imageWidth="280"
        :imageHeight="180"
        inputModelName="linkUrl"
        inputTitle="直播ID"
      ></ImageList>
    </div>
  </div>
</template>

<script>
import ImageList from './components/imageList'
import { imageTypes } from '@/common/utils/constant'
export default {
  name: 'imageSeeting',
  data () {
    return {
      imageTypes
    }
  },
  components: {
    ImageList
  }
}
</script>

<style lang="scss" scoped>
  .title {
    background: rgba(242, 242, 242, 1);
    padding: 5px 10px;
    color: #666666;
    font-weight: normal;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/views/SysManager/ExhibitionInfo/HomeSetup/index.vue